import { FC } from 'react';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import StatsTable from './components/StatsTable/StatsTable';
import Calculator from './components/Calculator/Calculator';
import styles from './index.module.scss';

export type IncomeBasedHeroProps =
  SliceComponentProps<Content.IncomeBasedHeroSlice>;

const IncomeBasedHero: FC<IncomeBasedHeroProps> = ({ slice }) => {
  return (
    <section
      className={styles.wrapper}
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <h1 className={`${styles.title} ${styles.desktopTitle}`}>
        {slice.primary.title}
      </h1>
      <h1 className={`${styles.title} ${styles.mobileTitle}`}>
        {slice.primary.mobile_title}
      </h1>
      <div className={styles.content}>
        <StatsTable data={slice} />
        <Calculator data={slice} />
      </div>
    </section>
  );
};

export default IncomeBasedHero;
